module.exports = __webpack_public_path__ + "fonts/manrope-medium.5bb04a07.otf";